import { memo, useMemo } from 'react';

import { useCart } from '@screens/Cart';
import { Divider } from '@shared/ui/Divider/Divider';
import { VStack } from '@shared/ui/Stack';

import { ProductCartItem } from '../ProductCartItem/ProductCartItem';
import { Top } from '../Top/Top';
import cls from './ProductsWrapper.module.scss';

export const ProductsWrapper = memo(() => {
  const { products } = useCart();

  const isActiveDeleteSelected = useMemo(() => products.some((item) => item.selected), [products]);
  const isActiveSelectAll = useMemo(() => products.every((item) => item.selected), [products]);

  return (
    <div className={cls.wrapper}>
      <Top
        selectAllValue={isActiveSelectAll}
        deleteDisabled={!isActiveDeleteSelected}
      />
      <Divider className={cls.divider} />
      <VStack className={cls.products}>
        {products.map((data) => (
          <ProductCartItem
            key={data.id}
            {...{ data }}
          />
        ))}
      </VStack>
    </div>
  );
});
